import { Checkbox } from "@screencloud/screencloud-ui-components";
import { FormattedMessage } from "react-intl";
import { CheckboxRow } from "../styles";

export interface SameAddressToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * "Use the same address for Shipping" checkbox. Controlled — owns no state, so
 * it is trivial to render and assert against in isolation.
 */
export function SameAddressToggle({
  checked,
  onChange,
}: SameAddressToggleProps) {
  return (
    <CheckboxRow>
      <Checkbox
        checked={checked}
        onChange={(_event, data) => onChange(!!data.checked)}
        data-testid="same-address-checkbox"
      />
      <span>
        <FormattedMessage
          id="pixi_wizard.payment_shipping.same_address"
          defaultMessage="Use the same address for Shipping"
        />
      </span>
    </CheckboxRow>
  );
}
